import React, { useRef } from 'react'
import DashHeader from '../mini/DashHeader';
import { useParams, NavLink } from 'react-router-dom';
import { useAllOrdersQuery } from '../../redux/services/ordersApi';

const RiderStatements = () => {
    
    const { riderId } = useParams()

    const { riderRH } = useAllOrdersQuery(undefined, {
        selectFromResult: ({data}) => ({
            riderRH: data?.data?.filter((order) => order?.rider?._id === riderId)
        })
    })
    const selectedUser = useRef('')
    
    
    const renderList = riderRH?.map((RH, index) => {
        
        const { _id, createdAt, fareAmount, pickAddress, dropAddress, status } = RH
        Date.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const d = new Date(createdAt)
        const time = d.toLocaleString('en-Us', { hour: 'numeric', minute: 'numeric', hour12: true })
        const date = Date.longMonths[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear()
        let txtColor
        selectedUser.current = RH?.rider?.fullName

        if (status === "on going") {
            txtColor = "text-warning"            
        } else if (status === "complete") {
            txtColor = "text-success" 
        } else {
            txtColor = "text-danger"
        }

        return (
            <tr key={index}>
                <td title={_id}>{_id.substring(0, 7) + '...'}</td>
                <td>{time}</td>
                <td>{date}</td>
                <td>{pickAddress}</td>
                <td>{dropAddress}</td>
                <td>&#8358;{fareAmount}</td>
                <td className={txtColor+" tstatus"}>{status}</td>
            </tr>
        )

    })

    return (
        <>
            <DashHeader title={selectedUser?.current || "Riders Statements"} />
            <nav className='mt-2 d-flex nav-tab'>
                <NavLink to={"/dashboard/rider/"+riderId} className="text-decoration-none d-inline-block ps-0 p-2 my-2 border-bottom-1 top-tab">
                    General information
                </NavLink>
                <NavLink to={"/dashboard/rider-history/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab">
                    Rider History
                </NavLink>
                <NavLink to={"/dashboard/statements/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab active-top-tab">
                    Statements
                </NavLink>
                <NavLink to={"/dashboard/documents/"+riderId} className="text-decoration-none d-inline-block pe-4 p-2 my-2 border-bottom-1 top-tab">
                    Documents
                </NavLink>
            </nav>
            <div className="input form-control w-40 mt-3 py-0 my-1 me-4">
                <i className="ri-search-line ri-lg pe-2"></i>
                <input type="text" placeholder="Search Users By Order ID, Name or Date" className="w-75 p-2 ps-0" />
            </div>
            <div className="pull-up">
                <section>
                    <div className="table-responsive my-4">
                        <table className="table text-center">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Time</th>
                                    <th>Date</th>
                                    <th>pick-up address</th>
                                    <th>drop-off address</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {renderList}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </>
    )
}

export default RiderStatements
